import { render } from "./PrepaymentInvoices.vue?vue&type=template&id=52611bde&scoped=true"
import script from "./PrepaymentInvoices.vue?vue&type=script&lang=js"
export * from "./PrepaymentInvoices.vue?vue&type=script&lang=js"

import "./PrepaymentInvoices.vue?vue&type=style&index=0&id=52611bde&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52611bde"]])

export default __exports__